import React from "react";

const Item = ({ label, value, ok, testid }) => (
  <span className="inline-flex items-center gap-1.5 whitespace-nowrap" data-testid={testid}>
    <span className="text-slate-500">{label}:</span>
    <span className={`font-medium ${ok ? "text-emerald-700" : "text-rose-700"}`}>{value}</span>
  </span>
);

export const tokenValid = (c) => !!c?.connected && c.health !== "reauth_required" && c.connection_status !== "reauth_required"
  && (!c.token_expires_at || new Date(c.token_expires_at) > new Date());

export const WaConnectionStatus = ({ cloud }) => {
  if (!cloud) return null;
  const connected = !!cloud.connected;
  const valid = tokenValid(cloud);
  return (
    <div className="rounded-xl border border-slate-200 bg-white px-4 py-2.5 text-sm flex flex-wrap items-center gap-x-5 gap-y-1.5" data-testid="wa-connection-status">
      <span className="inline-flex items-center gap-2 font-semibold text-slate-800" data-testid="wa-status-connection">
        <span className={`w-2 h-2 rounded-full ${connected ? "bg-emerald-500 shadow-[0_0_0_3px_rgba(16,185,129,0.15)]" : "bg-slate-300"}`} />
        Meta Cloud API: <span className={connected ? "text-emerald-700" : "text-slate-500"}>{connected ? "Connected" : "Not connected"}</span>
      </span>
      {connected && <>
        <Item label="WhatsApp number" value={cloud.display_phone_number || cloud.phone_number_id} ok testid="wa-status-number" />
        <Item label="Template management" value={cloud.templates_enabled ? "Enabled" : "Disabled"} ok={cloud.templates_enabled} testid="wa-status-templates" />
        <Item label="Access token" value={valid ? "Valid" : "Expired"} ok={valid} testid="wa-status-token" />
      </>}
    </div>
  );
};
